// @flow
import { path } from 'ramda'
import { getRadioChannelLanguages } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_RADIO_CHANNEL_LANGUAGES = 'radioChannels/FETCH_LANGUAGES'

const fetchRadioChannelLanguagesAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_RADIO_CHANNEL_LANGUAGES,
    payload: getRadioChannelLanguages(publicApi, serviceSpec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchRadioChannelLanguages = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchRadioChannelLanguagesAction(serviceSpec))

  const state = getState()
  const expires = path(['channelLanguages', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchRadioChannelLanguagesAction(serviceSpec))
}
